(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("SelectProductController", SelectProductController);

    /** @ngInject */
    function SelectProductController(
        $translate,
        $localStorage,
        toastr,
        StoreService,
        InvoicesService,
        StoreInfoFactory,
        systemConstants
    ) {
        var $ctrl = this;

        var AVAILABLE = 'available';

        $ctrl.readonly = $ctrl.readonly || false;
        $ctrl.errors = $ctrl.errors || {
            required: "entity.validation.required",
            minlength: "entity.validation.minlength",
            maxlength: "entity.validation.maxlength",
        };

        $ctrl.showErrorVariation = false;
        $ctrl.showErrorColor = false;

        $ctrl.updatePurchaseValue = function () {
            $ctrl.purchaseValue =
                $ctrl.invoice.subTotal +
                $ctrl.invoice.shippingValue -
                ($ctrl.invoice.discount ? $ctrl.invoice.discount : 0);
            if (
                !$ctrl.invoice.subTotal ||
                $ctrl.invoice.subTotal < 0 ||
                !$ctrl.purchaseValue ||
                $ctrl.purchaseValue < 0
            ) {
                $ctrl.purchaseValue = 0;
            }
        };

        $ctrl.calculatePrice = function () {
            if ($ctrl.invoice.item) {
                InvoicesService.calculateDiscount($ctrl.invoice).then(
                    function (response) {
                        if (response.data) {
                            $ctrl.invoice.discount = response.data;
                        } else {
                            $ctrl.invoice.discount = undefined;
                        }
                        $ctrl.updatePurchaseValue();
                    },
                    function (err) {
                        $ctrl.invoice.discount = undefined;
                        $ctrl.updatePurchaseValue();
                    }
                );
                var subTotal = 0;
                if ($ctrl.invoice.item.flyer.details && $ctrl.invoice.item.flyer.details.length) {
                    if ($ctrl.invoice.item.detail) {
                        subTotal +=
                        $ctrl.invoice.item.quantity *
                            ($ctrl.invoice.item.detail.discountedValue
                                ? $ctrl.invoice.item.detail.discountedValue
                                : $ctrl.invoice.item.detail.purchaseValue);
                    }
                } else {
                    subTotal +=
                    $ctrl.invoice.item.quantity *
                        ($ctrl.invoice.item.flyer.discountedValue
                            ? $ctrl.invoice.item.flyer.discountedValue
                            : $ctrl.invoice.item.flyer.purchaseValue);
                }
                $ctrl.invoice.subTotal = subTotal;
                if (!$ctrl.invoice.shippingValue) {
                    $ctrl.invoice.shippingValue = 0;
                }
                $ctrl.invoice.total = subTotal;
                $ctrl.updatePurchaseValue();
            }
        };

        $ctrl.hasErrorVariation = function () {
            if ($ctrl.selectProduct && $ctrl.selectProduct.flyer && !$ctrl.selectProduct.detail) {
                $ctrl.showErrorVariation = true;
            } else {
                $ctrl.showErrorVariation = false;
            }
        };

        $ctrl.hasErrorColor = function () {

            if ($ctrl.selectProduct && $ctrl.selectProduct.flyer) {
                var hasColor = $ctrl.selectProduct.flyer.details.some(function (
                    detail
                ) {
                    return (
                        detail.color &&
                        ((detail.size &&
                            detail.size === $ctrl.selectProduct.detail.size) ||
                            (detail.unit &&
                                detail.unit ===
                                    $ctrl.selectProduct.detail.unit))
                    );
                });

                if (hasColor) {
                    if ($ctrl.selectProduct && $ctrl.selectProduct.flyer && !$ctrl.selectProduct.color) {
                        $ctrl.showErrorColor = true;
                    } else {
                        $ctrl.showErrorColor = false;
                    }
                }
            }

        };

        if ($ctrl.model && $ctrl.model.id) {
            var item = {
                flyer: $ctrl.model,
                quantity: $ctrl.model.quantity || 1,
                detail: $ctrl.model.detail,
                color: $ctrl.model.detail && $ctrl.model.detail.color ? String($ctrl.model.detail.color.id) : null
            };
            $ctrl.invoice = {
                item: item,
            };
            $ctrl.calculatePrice();

            $ctrl.selectProduct = angular.copy($ctrl.invoice.item);
        } else {
            $ctrl.invoice = {
                item: null,
            };
        }

        $ctrl.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: StoreInfoFactory.getStoreId(),
                search: query,
            };
        };

        $ctrl.changeProduct = function (value) {
            if (value) {
                $ctrl.productInput = value;
            } else {
                $ctrl.productInput = null;
            }
        };

        StoreService.getStore($localStorage.defaultStore.storeId).then(
            function (response) {
                if (response && response.data) {
                    $ctrl.store = response.data;
                    $ctrl.storeCategory = response.data.categoryKey;
                    $ctrl.hubId = $ctrl.store.hubId;
                    $ctrl.isBrl = response.data.langKey === "pt-br";

                    $ctrl.isImmoContext = $ctrl.hubId === systemConstants.IMMO_HUB_ID;

                    loadCurrencyPrefix($ctrl.store);
                }
            }
        );

        $ctrl.getAvailableColors = function (size, details) {
            if (!size || !details) return [];

            // Filtra os detalhes pelo tamanho selecionado
            var detailsWithSize = details.filter(function (detail) {
                return detail.size === size;
            });

            // Extrai as cores únicas dos detalhes filtrados
            var colors = [];
            detailsWithSize.forEach(function (detail) {
                if (detail.color && !colors.some(function (c) { return c.id === detail.color.id; })) {
                    colors.push(detail.color);
                }
            });

            return colors;
        };

        function loadCurrencyPrefix(store) {
            $ctrl.invoice.currency = store.currency ? store.currency : "REAL";
            var config = getCurrencyListConfiguration()[$ctrl.invoice.currency];
            $ctrl.currencyPrefix = config.prefix;
        }

        $ctrl.selectedProduct = function (item) {
            var detail = null;
            var quantity = 1;
            var flyer = item.originalObject;

            if (!flyer.details && flyer.inventory === 0) {
                toastr.warning(
                    $translate.instant(
                        "salesFunnel.negotiation.product-without-inventory"
                    )
                );
                return;
            }

            $ctrl.invoice.item = {
                flyer: flyer,
                quantity: quantity,
                detail: detail,
            };
            $ctrl.calculatePrice();

            $ctrl.selectProduct = angular.copy($ctrl.invoice.item);

            $ctrl.hasErrorVariation();
        };

        $ctrl.filterSizes = function (details) {
            if (!details) return [];
            if ($ctrl.isImmoContext) {
                // Para contexto imobiliário, retorna todos os detalhes que têm unit
                return details.filter(function (detail) {
                    return detail.unit != null && detail.status === AVAILABLE;
                });
            }
            return details.filter(function (detail) {
                return detail.inventory == null || detail.inventory > 0;
            });
        };

        function verifyQuantityMessage(item, value) {
            if (
                item.flyer.details &&
                item.flyer.details.length > 0 &&
                !item.detail
            ) {
                toastr.warning(
                    $translate.instant(
                        "salesFunnel.negotiation.select-variation"
                    )
                );
            } else if (
                item.detail &&
                item.detail.inventory &&
                item.detail.inventory !== 0 &&
                (value === undefined || value > item.detail.inventory)
            ) {
                toastr.warning(
                    $translate.instant(
                        "salesFunnel.negotiation.limit-amount-reached"
                    )
                );
            } else if (
                !item.detail &&
                item.flyer.inventory &&
                item.flyer.inventory !== 0 &&
                (value === undefined || value > item.flyer.inventory)
            ) {
                toastr.warning(
                    $translate.instant(
                        "salesFunnel.negotiation.limit-amount-reached"
                    )
                );
            }
        }

        $ctrl.onChangeQuantity = function (item) {
            verifyQuantityMessage(item, item.quantity);
            if (item.quantity < 0) {
                item.quantity = 0;
            } else if (
                item.detail &&
                (item.quantity === undefined ||
                    item.quantity > item.detail.inventory)
            ) {
                item.quantity = item.detail.inventory;
            } else if (
                !item.detail &&
                item.flyer.inventory &&
                item.flyer.inventory !== 0 &&
                (item.quantity === undefined ||
                    item.quantity > item.flyer.inventory)
            ) {
                item.quantity = item.flyer.inventory;
            }

            $ctrl.calculatePrice();
        };

        $ctrl.deleteProduct = function (index) {
            $ctrl.invoice.item = null;
            $ctrl.calculatePrice();

            $ctrl.showErrorVariation = false;
            $ctrl.showErrorColor = false;

            $ctrl.selectProduct = angular.copy($ctrl.invoice.item);
            if ($ctrl.onChange) {
                $ctrl.onChange($ctrl.invoice.item);
            }
        };

        $ctrl.onVariationChange = function (item, index) {
            item.quantity = 1;
            item.color = null;
            $ctrl.calculatePrice();

            $ctrl.selectProduct = angular.copy(item);

            $ctrl.hasErrorVariation();
            $ctrl.hasErrorColor();

            $ctrl.onChange({ newValue: item });
        };

        $ctrl.getItemSubtotal = function (item) {
            var subTotal = 0;
            if (item.flyer.details && item.flyer.details.length) {
                if (item.detail) {
                    var value = item.detail.discountedValue ? item.detail.discountedValue : item.detail.purchaseValue;
                    subTotal += item.quantity * value;
                }
            } else {
                subTotal += item.quantity * (item.flyer.discountedValue ? item.flyer.discountedValue : item.flyer.purchaseValue);
            }

            return subTotal;
        }

        $ctrl.updateDetailWithColor = function (item) {
            var colorId = parseInt(item.color);

            // Encontra o detail com o mesmo tamanho e cor
            var newDetail = item.flyer.details.find(function (detail) {
                return detail.size === item.detail.size &&
                    detail.color &&
                    detail.color.id === colorId;
            });

            if (newDetail) {
                item.detail = angular.copy(newDetail);
                $ctrl.calculatePrice();

                $ctrl.selectProduct = angular.copy(item);

                $ctrl.hasErrorVariation();
                $ctrl.hasErrorColor();
            }

        };

    }
})();
